module.exports = __webpack_public_path__ + "media/images/guideline/sell_01-fbdcb6cb2bc742a27f4ac3054e2cd61f.jpg";